var _defs, _path, _polygon, _rect, _path2, _polygon2, _polygon3, _path3, _polygon4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfisterer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 648.6 596.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: white;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.5,327h21.3v-16.8h22.8c15.1,0,20.5-8,20.5-18.3s-5.6-18.8-20.6-18.8H7.5v53.9ZM28.7,285.8h13.7c5.4,0,7.4,1.7,7.4,5.7s-2,5.6-7.4,5.6h-13.7v-11.3Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.4 273.2 139.9 273.2 139.9 286.3 106.6 286.3 106.6 294.5 133.7 294.5 133.7 307.6 106.6 307.6 106.6 327 85.4 327 85.4 273.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.3,
    y: 273.2,
    width: 21.3,
    height: 53.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.7,304.2c-10.4-1.6-14.7-7.6-14.7-15.2,0-14,13.7-17.7,31.2-17.7s33.9,6.3,34.6,17.7h-24.8c0-2.2-1.3-3.5-3.2-4.3-1.9-.8-4.3-1.1-6.6-1.1-6.3,0-8.5,1.6-8.5,3.8s.7,2.5,2.8,2.8l25.4,3.8c10.7,1.6,17.3,6.6,17.3,15.7,0,13.1-10.7,19.3-34.6,19.3s-34.3-2.3-34.3-18.1h25.7c0,1.8.8,3,2.3,3.9,1.6.7,3.9,1.1,7.2,1.1,6.6,0,8.4-1.8,8.4-4.4s-1-3.2-3.8-3.6l-24.3-3.6Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "283.7 286.7 264 286.7 264 273.2 324.7 273.2 324.7 286.7 305 286.7 305 327 283.7 327 283.7 286.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "334.4 273.2 393.5 273.2 393.5 286.3 355.7 286.3 355.7 293.5 385.6 293.5 385.6 306.7 355.7 306.7 355.7 313.9 395.3 313.9 395.3 327 334.4 327 334.4 273.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.3,327h21.3v-16.6h15.1c3.9,0,5.3,2.4,5.5,6.4.4,6.3.4,8.6,1.1,10.2h23.2c-1.3-1.6-2.4-3.9-2.6-6.3l-.9-11.8c-.4-4.7-3-7.4-6.1-8.3v-.2c6.2-1.8,8.3-7.2,8.3-12.3s-3.3-11.1-7.3-13.1c-2.9-1.4-6.6-2-12.7-2h-44.8v53.9ZM434.6,286.7h14.8c3.5,0,6.2,1,6.2,5.1s-1.7,5.1-5.9,5.1h-15.1v-10.1Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "496.7 273.2 555.7 273.2 555.7 286.3 518 286.3 518 293.5 547.9 293.5 547.9 306.7 518 306.7 518 313.9 557.5 313.9 557.5 327 496.7 327 496.7 273.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.2,327h21.3v-16.6h15.1c3.9,0,5.3,2.4,5.5,6.4.4,6.3.4,8.6,1.1,10.2h23.2c-1.4-1.6-2.4-3.9-2.6-6.3l-.9-11.8c-.4-4.7-2.9-7.4-6.1-8.3v-.2c6.2-1.8,8.3-7.2,8.3-12.3s-3.3-11.1-7.3-13.1c-2.9-1.4-6.6-2-12.7-2h-44.8v53.9ZM596.4,286.7h14.8c3.5,0,6.2,1,6.2,5.1s-1.7,5.1-5.9,5.1h-15.1v-10.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfisterer);
export default __webpack_public_path__ + "static/media/pfisterer.83605fd89be55a8861ed7ab4b1c8df9d.svg";
export { ForwardRef as ReactComponent };